import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Opportunity-Talents" }
const _hoisted_2 = { class: "App-Opportunity-Opp" }
const _hoisted_3 = { class: "App-Opportunity-Opp-L" }
const _hoisted_4 = { "mute-primary": "" }
const _hoisted_5 = { "mute-primary": "" }
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_app_over_avatars = _resolveComponent("app-over-avatars")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_talentsList = _resolveComponent("talentsList")!
  const _component_app_loader_talents = _resolveComponent("app-loader-talents")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_space, {
        style: {"justify-content":"space-between"},
        "w-100": "",
        size: 10,
        justify: "space-between"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.showHeader)
              ? (_openBlock(), _createBlock(_component_app_over_avatars, {
                  key: 0,
                  size: 50
                }, {
                  one: _withCtx(() => [
                    _createVNode(_component_el_avatar, {
                      src: _ctx.opportunity.createdBy.avatar,
                      icon: "el-icon-user-solid",
                      size: 45
                    }, null, 8, ["src"])
                  ]),
                  two: _withCtx(() => [
                    _createVNode(_component_el_avatar, {
                      src: _ctx.opportunity.business.avatar,
                      icon: "el-icon-office-building",
                      size: 45
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("h4", null, [
                _createTextVNode(_toDisplayString(_ctx.opportunity.outcome) + " / ", 1),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.opportunity.skill[1]), 1)
              ]),
              _createVNode(_component_el_space, {
                wrap: "",
                alignment: "center",
                size: 8
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.business.name), 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$filters.capitalize(_ctx.$moment(_ctx.opportunity.createdAt).fromNow())), 1)
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.showLink)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: `/opportunities/${_ctx.opportunity._id}`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_link, { type: "primary" }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("View Details", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    (_ctx.talents)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_talentsList, {
            opportunity: _ctx.opportunity,
            talents: _ctx.ignoreRegionFilter ? _ctx.otherTalents : _ctx.talents
          }, null, 8, ["opportunity", "talents"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.otherTalents.length == 0)
      ? (_openBlock(), _createBlock(_component_app_loader_talents, {
          key: 1,
          loading: _ctx.loading,
          resources: _ctx.talents,
          description: "Can't find any talents to match <br /> with on this opportunity."
        }, null, 8, ["loading", "resources"]))
      : _createCommentVNode("", true),
    (
        _ctx.talents.length === 0 &&
        _ctx.otherTalents.length !== 0 &&
        _ctx.ignoreRegionFilter == false
      )
      ? (_openBlock(), _createBlock(_component_app_loader_talents, {
          key: 2,
          loading: _ctx.loading,
          class: "App-Other-Talents-Available",
          description: `Based on your region filter we couldn't find talents,<br />but there are <b style='color:black;'>${_ctx.otherTalents.length} talents from other regions</b>!`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ignoreRegionFilter = true)),
              type: "primary"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Ignore Region Filter ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "description"]))
      : _createCommentVNode("", true)
  ]))
}